/**
 * Copyright 2018-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../components/Icon';

export default class LayerTreeInfoText extends React.Component {
    static propTypes = {
    }
    static defaultProps = {
    }
    render() {
            return (
                <div className="layertree-option layertree-infoPlace">
                    <p><b> <Icon icon="cog"/> kuvakkeesta voi vaihtaa tasojen järjestystä ja himmentää yksittäistä karttatasoa.</b></p>
                </div>
            );
    }
}
